<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img src="../../assets/img_public/support/h5_banner01.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box">
					<div class="tit_b"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>{{ $t('support.text1') }}</div>
					<div class="tit"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>{{ $t('support.text2') }}</div>
				</div>
			</div>
			<!--banner-->
			<!--子导航-->
			<div class="nav_list"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="400"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div
					v-for="(value, index) in navList"
					:key="index"
					class="nav_el"
					:class="isActived == index ? 'avtived' : ''"
					@click="navChange(index)"
				>
					<div>{{ value.title }}</div>
				</div>
			</div>
			<!--子导航-->
			<!--技术支持-->
			<template v-if="isActived == 0">
				<jszc></jszc>
			</template>
			<!--技术支持-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import jszc from './jszc/index_h5.vue'  //技术支持
export default {
	components:{
		navBox,
		footerBox,
		jszc
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[4].children;
			switch(that.$route.params.newsId) {
				case 'support.html':
					that.isActived = 0;
				break;
			}
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.nav_list{
		display: flex;
		border-bottom: 1px solid #E3E1E6;
		.nav_el{
			flex: 1;
			text-align: center;
			div{
				display: inline-block;
				padding: 16px 0 12px 0;
				font-size: 16px;
			}
		}
		.nav_el.avtived{
			div{
				border-bottom: 1px solid #A50073;
				color: #A50073;
			}
		}
	}
	//轮播
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			margin: 0 auto;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			padding: 0 20px;
			.tit{
				margin-top: 0px;
				font-size: 13px;
			}
			.tit_b{
				font-size: 24px;
				font-weight: bold;
				color: #A50073;
			}
		}
		img{
			width: 100%;
		}
	}
}
</style>